import { supabase, PAPERS_TABLE } from "@/lib/supabase";

// তালিকায় paper_json আনা হয় না — প্রতিটা পেপারের JSON বড় (egress বাঁচাতে), খোলার সময় আলাদা আনা হয়।
const LIST_FIELDS =
  "id, slug, title, teacher_name, institution, class_level, subject, exam_type, medium, term_values, status, copy_count, view_count, created_at, moderation_note";

export async function fetchPapersByStatus(status) {
  const { data, error } = await supabase
    .from(PAPERS_TABLE)
    .select(LIST_FIELDS)
    .eq("status", status)
    .order("created_at", { ascending: false })
    .limit(200);
  if (error) throw error;
  return data ?? [];
}

export async function fetchPaperJson(id) {
  const { data, error } = await supabase.from(PAPERS_TABLE).select("paper_json").eq("id", id).single();
  if (error) throw error;
  return data.paper_json;
}

export async function approvePaper(id) {
  const { error } = await supabase.from(PAPERS_TABLE).update({ status: "approved" }).eq("id", id);
  if (error) throw error;
}

export async function unpublishPaper(id) {
  const { error } = await supabase.from(PAPERS_TABLE).update({ status: "unpublished" }).eq("id", id);
  if (error) throw error;
}

// রিজেক্ট = কনটেন্ট মুছে একটা ছোট tombstone রাখা (কারণসহ — লেখক সেটা দেখতে পায়)।
// মোছার কাজটা ডাটাবেসের trigger করে (migration 0003), ক্লায়েন্ট শুধু status + কারণ পাঠায়।
export async function rejectPaper(id, note) {
  const { error } = await supabase
    .from(PAPERS_TABLE)
    .update({ status: "rejected", moderation_note: note?.trim() || null })
    .eq("id", id);
  if (error) throw error;
}

// hard delete — শুধু admin (RLS)। moderator-দের জন্য "আনপাবলিশ"।
export async function deletePaper(id) {
  const { error } = await supabase.from(PAPERS_TABLE).delete().eq("id", id);
  if (error) throw error;
}

// ট্যাগ ঠিক করা (শুধু মডারেটর/অ্যাডমিন)। বৈধতা যাচাই করে ডাটাবেসের trigger (migration 0005) —
// সক্রিয় ক্যাটাগরির সক্রিয় মান ছাড়া কিছু নিলে `gallery:invalid_terms` error আসে।
export async function updatePaperTags(id, tags) {
  const { data, error } = await supabase.from(PAPERS_TABLE).update({ term_values: tags }).eq("id", id).select("term_values");
  if (error) throw error;
  if (!data?.length) throw new Error("gallery:not_allowed");
  return data[0].term_values;
}
